module.exports = __webpack_public_path__ + "static/fonts/ionicons.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/iview/dist/styles/fonts/ionicons.ttf?v=3.0.0
// module id = 87
// module chunks = 83